import React from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import UiContent from '../../Components/Common/UiContent';
import PersonalProtectiveEquipmentSupplyList from './PersonalProtectiveEquipmentSupplyList';


//redux

const PersonalProtectiveEquipmentSupply = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '#', label: 'Gestión de EPP', icon: 'icon-shirt' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Control de EPP' links={breadcrumbLinks} icon={'icon-circle-gauge'}/>
					<PersonalProtectiveEquipmentSupplyList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipmentSupply;
